import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-ink/10 bg-cream py-10" data-id="element-63" data-mp="32wd2cf6gdjt0">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-4 text-center sm:px-6" data-id="element-64" data-mp="3ggarzyv0aj71">
        <p className="font-display text-2xl font-black text-ink" data-id="element-65" data-mp="32ovwwtntqrjm">MakerLab</p>
        <p className="max-w-md text-sm text-ink/50" data-id="element-66" data-mp="36oxzr65apr0h">
          100+ praktische Roboter-Projekte für Kinder — gebaut aus einfachen
          Alltagsmaterialien, geführt durch Schritt-für-Schritt-PDF-Anleitungen.
        </p>
        <p className="mt-4 text-xs text-ink/40" data-id="element-67" data-mp="37o7wzgy05fh">
          © {new Date().getFullYear()} MakerLab. Alle Rechte vorbehalten.
          Sofortiger digitaler Download.
        </p>
      </div>
    </footer>;
}